import ReviewsTableRow from './ReviewsTableRow';

export default ReviewsTableRow;
